import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
const getSocialLinkActionsData = args => {
  return {
    dataSeleniumTest: 'chicklet-social-profile-btn',
    dataTestId: 'chicklet-social-profile-btn',
    label: I18n.text('cardAssociatedObjects.chicklet.SocialProfileInboxButton'),
    href: `/social-insights/${PortalIdParser.get()}/inbox/`,
    external: true,
    disabled: !args.canEdit,
    onClick: () => {
      CrmLogger.log('sidebar-interaction', {
        action: 'social profile - click inbox'
      });
    }
  };
};
export const SocialProfileChickletHoverActions = args => {
  return {
    SecondaryActions: [getSocialLinkActionsData(args)]
  };
};